import React from "react";

interface SectionHeaderProps {
  icon: React.ReactNode;
  title: string;
  description?: string;
}

const SectionHeader = ({ icon, title, description }: SectionHeaderProps) => {
  return (
    <div className="bg-[#fafbfc] px-5 py-4 -mx-5 -mt-5 mb-6 flex items-center gap-2 rounded-t-2xl">
      <div className="p-2 bg-amber-100 rounded-md text-amber-500">{icon}</div>
      <div className="flex-1">
        <h3 className="text-lg font-medium">{title}</h3>
        {description && (
          <p className="text-sm text-gray-600 mt-1">{description}</p>
        )}
      </div>
    </div>
  );
};

export default SectionHeader;
